import React from "react";

interface Props {
  content: string;
  title: string;
  metadata?: {
    embedded_url?: string;
    thumbnail_url?: string;
  };
}

export const isRumbleLink = (url?: string): boolean => {
  if (!url) return false;

  try {
    const { hostname } = new URL(url.trim());
    return hostname === "rumble.com" || hostname.endsWith(".rumble.com");
  } catch {
    return /rumble\.com/i.test(url);
  }
};

const RumbleStudyMaterialCard: React.FC<Props> = ({ content, title, metadata }) => {
  const thumbnailUrl = metadata?.thumbnail_url;
  const embedUrl = metadata?.embedded_url;

  return (
    <div className="mt-2">
      {thumbnailUrl && (
        <div className="mb-2">
          <img
            src={thumbnailUrl}
            alt={`${title} thumbnail`}
            className="rounded"
            style={{ width: "128px", height: "72px", objectFit: "cover" }}
            onError={(e) => {
              (e.target as HTMLImageElement).style.display = "none";
            }}
          />
        </div>
      )}

      <a
        href={content}
        target="_blank"
        rel="noopener noreferrer"
        className="text-primary fs-13 d-block"
      >
        <i className="ti ti-external-link me-1" />
        {content}
      </a>

      {embedUrl && (
        <div className="mt-2">
          <span className="text-muted fs-12 d-block mb-1">Embed URL</span>
          <a
            href={embedUrl}
            target="_blank"
            rel="noopener noreferrer"
            className="text-primary fs-13"
          >
            <i className="ti ti-code me-1" />
            {embedUrl}
          </a>
        </div>
      )}
    </div>
  );
};

export default RumbleStudyMaterialCard;
